import { render, staticRenderFns } from "./create-certificate-index.vue?vue&type=template&id=7888e7e8&scoped=true"
import script from "@/components/create-certificate/index/create-certificate-index.js?vue&type=script&lang=js&external"
export * from "@/components/create-certificate/index/create-certificate-index.js?vue&type=script&lang=js&external"
import style0 from "./create-certificate-index.vue?vue&type=style&index=0&id=7888e7e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7888e7e8",
  null
  
)

export default component.exports